import { render, staticRenderFns } from "./OrgInfo.vue?vue&type=template&id=47c0d70b&scoped=true"
import script from "./OrgInfo.vue?vue&type=script&lang=js"
export * from "./OrgInfo.vue?vue&type=script&lang=js"
import style0 from "./OrgInfo.vue?vue&type=style&index=0&id=47c0d70b&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c0d70b",
  null
  
)

export default component.exports